<template>
	<BaseCard
		:title="$t('contact_data').toString()"
		:is-toggle-open="isToggleOpen"
		:hint="isUserAllowedInLevel5or6 ? $t('scan_qr_code').toString() : null"
		:is-toggleable="true"
		@toggleCard="toggleCard($event)"
	>
		<div v-if="process && process.customer" class="flex flex-wrap -mt-8">
			<div v-if="!isUserAllowedInLevel2" class="flex-shrink mt-8 max-w-full" :class="!isUserAllowedInLevel5or6 ? 'w-full' : ''">
				<div class="text-left leading-none flex flex-col space-y-2 mb-8">
					<div class="grid grid-cols-2 max-w-full w-full" :class="isUserAllowedInLevel5or6 ? 'cursor-pointer' : ''" @click="redirectToCustomer">
						<div class="font-bold" :class="isUserAllowedInLevel5or6 ? 'w-24 flex-shrink-0' : ''">{{ $t('customer_input') }}</div>
						<div class="break-words" v-if="process.customer.gender === 'company'">{{ process.customer.company.name }}</div>
						<div class="break-words" v-if="process.customer.gender !== 'company'">{{ customerName }}</div>
					</div>

					<div class="grid grid-cols-2 max-w-full w-full">
						<div class="font-bold" :class="isUserAllowedInLevel5or6 ? 'w-24 flex-shrink-0' : ''">{{ $t('vehicle_license_plate_input') }}</div>
						<div class="break-words">{{ licensePlate }}</div>
					</div>

					<div class="grid grid-cols-2 max-w-full w-full">
						<div class="font-bold" :class="isUserAllowedInLevel5or6 ? 'w-24 flex-shrink-0' : ''">{{ $t('vehicle_input') }}</div>
						<div class="flex-shrink" :class="isUserAllowedInLevel5or6 ? 'w-48' : ''">{{ vehicleDescription }}</div>
					</div>

					<div class="grid grid-cols-2 max-w-full w-full" :class="isUserAllowedInLevel5or6 ? 'cursor-pointer' : ''" @click="redirectToVehicle">
						<div class="font-bold" :class="isUserAllowedInLevel5or6 ? 'w-24 flex-shrink-0' : ''">{{ $t('vehicle_fin_input') }}</div>
						<div class="break-words">{{ vehicleIdentificationNumber.toUpperCase() }}</div>
					</div>
					<div class="grid grid-cols-2 max-w-full w-full">
						<div class="font-bold">{{ $t('rentalcar_class') }}:</div>
						<div class="break-words" v-if="rentalCarClass">{{ $t('class') }} {{ rentalCarClass }}</div>
						<div class="break-words" v-else>{{ $t('not_stored_yet') }}</div>
					</div>

					<div class="grid grid-cols-2 max-w-full w-full" v-if="isUserAllowedInLevel2">
						<div class="font-bold">{{ $t('address_input') }}</div>
						<div class="flex-shrink">{{ customerAddress }}</div>
					</div>

					<div class="grid grid-cols-2 max-w-full w-full" v-if="isUserAllowedInLevel2 && customer.email">
						<div class="font-bold">{{ $t('e_mail_input') }}</div>
						<div class="flex-shrink">{{ customer.email }}</div>
					</div>

					<div class="grid grid-cols-2 max-w-full w-full" v-if="isUserAllowedInLevel2 && (customer.phone || customer.phoneNumber)">
						<div class="font-bold">{{ $t('phone_input') }}</div>
						<div class="flex-shrink">{{ customer.phone || customer.phoneNumber }}</div>
					</div>
				</div>
				<div v-if="process.contractingAuthorities != null && process.contractingAuthorities.length > 0">
					<div
						class="text-left leading-none flex flex-col space-y-2 mb-8"
						v-for="contractingAuthority in process.contractingAuthorities"
						:key="contractingAuthority.id"
					>
						<div class="grid grid-cols-2 max-w-full w-full">
							<div class="font-bold" :class="isUserAllowedInLevel5or6 ? 'w-24 flex-shrink-0' : ''">{{ $t('client') }}:</div>
							<div class="break-words" v-if="contractingAuthority.person.gender === 'company'">{{ contractingAuthority.person.organisation }}</div>
							<div class="break-words">{{ contractingAuthority.person.firstName }} {{ contractingAuthority.person.lastName }}</div>
						</div>
						<div class="grid grid-cols-2 max-w-full w-full">
							<div class="font-bold" :class="isUserAllowedInLevel5or6 ? 'w-24 flex-shrink-0' : ''">{{ $t('street') }}:</div>
							<div class="break-words">{{ contractingAuthority.person.street }} {{ contractingAuthority.person.houseNumber }}</div>
						</div>
						<div class="grid grid-cols-2 max-w-full w-full">
							<div class="font-bold" :class="isUserAllowedInLevel5or6 ? 'w-24 flex-shrink-0' : ''">{{ $t('city') }}:</div>
							<div class="break-words">{{ contractingAuthority.person.city.zipCode }} {{ contractingAuthority.person.city.name }}</div>
						</div>
						<div class="grid grid-cols-2 max-w-full w-full">
							<div class="font-bold" :class="isUserAllowedInLevel5or6 ? 'w-24 flex-shrink-0' : ''">{{ $t('phone') }}:</div>
							<div class="break-words">{{ contractingAuthority.person.phoneNumber }}</div>
						</div>
						<div class="grid grid-cols-2 max-w-full w-full" v-if="contractingAuthority.person.email != null">
							<div class="font-bold" :class="isUserAllowedInLevel5or6 ? 'w-24 flex-shrink-0' : ''">{{ $t('e_mail') }}:</div>
							<div class="break-words">{{ contractingAuthority.person.email }}</div>
						</div>
					</div>
				</div>

				<div v-if="isUserAllowedInLevel5or6">
					<div class="grid grid-cols-2">
						<div class="font-bold mb-2 w-full flex-shrink-0">{{ $t('vehicle_employee_sheet') }}</div>
						<div>
							<vue-qrcode :value="getQrLink" :margin="0" />
							<BaseButton class="mt-4" style="width: 180px;" @click="printDocument()" :disabled="!pdfBlob">
								<font-awesome-icon :icon="['fas', 'spinner']" class="mr-2" spin v-if="!pdfBlob" />
								{{ $t('print') }}
							</BaseButton>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="flex-shrink mt-8 max-w-full w-full">
				<div class="grid grid-cols-2 max-w-full w-full">
					<div class="font-bold">{{ $t('customer_input') }}</div>
					<div class="break-words" v-if="process.customer.gender === 'company'">{{ process.customer.company.name }}</div>
					<div class="break-words" v-if="process.customer.gender !== 'company'">{{ customerName }}</div>
				</div>
				<div class="grid grid-cols-2 max-w-full w-full" v-if="isUserAllowedInLevel2">
					<div class="font-bold">{{ $t('address_input') }}</div>
					<div class="flex-shrink">{{ customerAddress }}</div>
				</div>

				<div class="grid grid-cols-2 max-w-full w-full" v-if="isUserAllowedInLevel2 && customer.email">
					<div class="font-bold">{{ $t('e_mail_input') }}</div>
					<div class="flex-shrink">{{ customer.email }}</div>
				</div>

				<div class="grid grid-cols-2 max-w-full w-full" v-if="isUserAllowedInLevel2 && (customer.phone || customer.phoneNumber)">
					<div class="font-bold">{{ $t('phone_input') }}</div>
					<div class="flex-shrink">{{ customer.phone || customer.phoneNumber }}</div>
				</div>

				<h3 class="w-full text-connectProBlue font-bold mt-6 mb-2">{{ $t('vehicle_data') }}</h3>

				<div class="grid grid-cols-2 max-w-full w-full">
					<div class="font-bold">{{ $t('vehicle_input') }}</div>
					<div class="flex-shrink">{{ vehicleDescription }}</div>
				</div>

				<div class="grid grid-cols-2 max-w-full w-full">
					<div class="font-bold">{{ $t('vehicle_license_plate_input') }}</div>
					<div class="break-words">{{ licensePlate }}</div>
				</div>

				<div class="grid grid-cols-2 max-w-full w-full">
					<div class="font-bold">{{ $t('vehicle_fin_input') }}</div>
					<div class="break-words">{{ vehicleIdentificationNumber.toUpperCase() }}</div>
				</div>

				<div class="grid grid-cols-2 max-w-full w-full" v-if="rentalCarClass">
					<div class="font-bold">{{ $t('rentalcar_class') }}:</div>
					<div class="break-words">{{ $t('class') }} {{ rentalCarClass }}</div>
				</div>

				<div class="grid grid-cols-2 max-w-full w-full">
					<div class="font-bold">{{ $t('previous_owner_amount') }}:</div>
					<div class="break-words">{{ previousOwnersCount }}</div>
				</div>
			</div>
		</div>
	</BaseCard>
</template>

<script>
import VueQrcode from 'vue-qrcode';
import BaseButton from '@/components/forms/buttons/BaseButton';
import { concatArray } from '@/plugins/Utils';
import apiDefaults from '@/api/defaultConfiguration';
import { PdfApiFactory } from '@/api/generated';
import BaseCard from '@/components/damagecases/forms/BaseCard';
import Authentication from '@/mixins/Authentication';
import AppContainerMixin from '@/mixins/AppContainerMixin';

export default {
	name: 'ProcessDatasheetCard',
	components: { BaseCard, BaseButton, VueQrcode },
	mixins: [Authentication, AppContainerMixin],
	props: {
		process: { required: true },
		isToggleOpen: { type: Boolean, default: true },
	},
	data() {
		return {
			pdfBlob: null,
			documentName: '',
		};
	},
	computed: {
		getTitle() {
			return this.isUserAllowedInLevel2 ? this.$t('customer_data') : this.$t('core_data');
		},
		getQrLink() {
			return 'imd-connect-pro-employee://imdnet=' + this.process.imdNetId + '&qrkey=' + this.process.qrkey;
		},
		customerAddress() {
			const street = this.customer.street + (this.customer.houseNumber !== null ? ' ' + this.customer.houseNumber : '');
			return concatArray([street + ',', this.customer.city.zipCode, this.customer.city.name]);
		},
		customerName: function() {
			return concatArray([this.process.customer.title, this.process.customer.firstName, this.process.customer.lastName]);
		},
		customer() {
			return this.process?.customer;
		},
		vehicleDescription() {
			return this.process?.vehicle?.manufacturer + ' ' + this.process?.vehicle?.model;
		},
		vehicleIdentificationNumber() {
			return this.process?.vehicle?.vehicleIdentificationNumber;
		},
		previousOwnersCount() {
			return this.process?.vehicle?.numberOfPreviousOwners;
		},
		rentalCarClass() {
			return this.process?.replacementRentalCarClass;
		},
		licensePlate() {
			return this.process?.vehicle?.licensePlate.text;
		},
	},
	methods: {
		redirectToCustomer() {
			if (this.isUserAllowedInLevel5or6) {
				this.$router.push({ name: 'management.customer.overview', params: { customer: this.customer.id } });
			}
		},
		redirectToVehicle() {
			if (this.isUserAllowedInLevel5or6) {
				this.$router.push({
					name: 'management.customer.vehicles.edit',
					params: { customer: this.customer.id, vehicleId: this.process.vehicle.id },
				});
			}
		},
		toggleCard($event) {
			this.$emit('toggleCard', $event);
		},
		printDocument() {
			if (this.isAppContainer) {
				const reader = new FileReader();
				const name = this.documentName;
				reader.onload = function() {
					const arrayBuffer = this.result;
					// convert the ArrayBuffer to a comma-separated string
					const dataString = new Uint8Array(arrayBuffer).join(',');
					const messageData = {
						fileName: name,
						data: dataString,
					};
					// send the data to Swift
					window.webkit.messageHandlers.pdfHandler.postMessage(JSON.stringify(messageData));
				};
				reader.readAsArrayBuffer(this.pdfBlob);
			} else {
				const resolvingUrl = URL.createObjectURL(this.pdfBlob) + '#toolbar=1&navpanes=0&scrollbar=0';
				const viewerUrl = `/blobviewer?blobUrl=${encodeURIComponent(resolvingUrl)}&title=${encodeURIComponent(this.documentName)}`;

				setTimeout(function() {
					window.open(viewerUrl, '_blank');
					window.URL.revokeObjectURL(viewerUrl);
				}, 200);
			}
		},
	},
	mounted() {
		this.$store.dispatch('updateDamageCase', { id: parseInt(this.$route.params.processId || this.$route.params.id) }).then(() => {
			if (this.isUserAllowedInLevel5or6) {
				PdfApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.pdfDamagecasesIdTempQrsheetGet(this.process.id)
					.then(result => {
						let fileName = '';
						if (this.process.imdNetId) {
							fileName = this.process.imdNetId + '_QR-Code-Datenblatt.pdf';
						} else {
							fileName = 'QR-Code-Datenblatt.pdf';
						}

						PdfApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
							.pdfDamagecasesUuidTempFileGet(result.data.uuid, fileName)
							.then(response => {
								this.pdfBlob = new Blob([response.data], { type: 'application/pdf' });
								this.documentName = response.headers['content-disposition'].split('filename=')[1];
							});
					});
			}
		});
	},
};
</script>

<style scoped></style>
